var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:_vm.disableButton ? 'disable' : 'enable',attrs:{"disabled":_vm.disableButton}},[(_vm.hasRequest)?_c('spinner-component',{attrs:{"styles":_vm.buttonSpinner}}):_c('div',[_vm._v(" "+_vm._s(_vm.text)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }